import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@volca/ui/components/ui/select";
import type { AccessLevel } from "./types";

const LEVEL_LABELS: Record<AccessLevel, string> = {
  view: "View only",
  edit: "Can edit",
};

interface LevelSelectProps {
  value: AccessLevel;
  label: string;
  disabled?: boolean;
  onChange: (level: AccessLevel) => void;
}

export const LevelSelect = ({
  value,
  label,
  disabled,
  onChange,
}: LevelSelectProps) => (
  <Select
    value={value}
    items={LEVEL_LABELS}
    disabled={disabled}
    onValueChange={(level) => {
      if (level) onChange(level);
    }}
  >
    <SelectTrigger aria-label={label} className="w-36">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        <SelectItem value="view">{LEVEL_LABELS.view}</SelectItem>
        <SelectItem value="edit">{LEVEL_LABELS.edit}</SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
);
